export function getFormSubmitAPI(formType) {
    switch(formType) {
        case "ProducedShowForm":
            return "https://x0ef9gmy0e.execute-api.us-east-2.amazonaws.com/default/createProducedEventbrite";
        default:
            return "https://55a78c1z0h.execute-api.us-east-2.amazonaws.com/default/submitForm";
    }
}